// Multivariate dependencies
import React from 'react';
// Components
import { ContainerLegacy } from '../styles/Containers/ContainerLegacy';
// Styles
import { baseTheme } from '../common/styles/themes/styles/baseTheme';
// Utils
import { renderToolBarItems } from './utils/renderToolBarItems';
/**
 * Renders the toolbar for the app with the toolbar items
 *
 * @deprecated Do not use legacy components anymore.
 * @param {ToolBarProps} props { leftToolBarItems, rightToolBarItems }
 *
 * @returns {React.ElementType} - returns the toolbar element.
 */
export var ToolBar = function (_a) {
    var leftToolBarItems = _a.leftToolBarItems, rightToolBarItems = _a.rightToolBarItems;
    return (React.createElement(ContainerLegacy, { "data-testid": 'toolBar', as: 'section', border: '1px solid grey', borderTop: '0', borderBottom: '0', borderRadius: '0 6px 0 0', backgroundColor: baseTheme.backgroundTertiary, display: 'flex', justifyContent: 'space-between' },
        React.createElement(ContainerLegacy, { as: 'div', id: 'left-items', display: 'flex', flexWrap: 'wrap', margin: '5px' }, renderToolBarItems(leftToolBarItems)),
        React.createElement(ContainerLegacy, { as: 'div', id: 'right-items', margin: '5px' }, renderToolBarItems(rightToolBarItems))));
};
//# sourceMappingURL=Toolbar.js.map